import Vue from 'vue'
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Message,
  Popover,
  Button
} from 'element-ui'

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Popover)
Vue.use(Dialog)
Vue.component(Message)
Vue.component(Button.name, Button)
Vue.prototype.$message = Message
